module.exports = __webpack_public_path__ + "static/media/gameplay1-en.2501438b.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Spill/static/gameplay1-en.png
// module id = 186
// module chunks = 0